var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"f15fad0dcf82ae2da1989751be7555fb3e64989f"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["itdzobs@loyalgenie"]={id:"f15fad0dcf82ae2da1989751be7555fb3e64989f"};
      